<template>
  <main
    class="wrap-bg"
    :style="{ backgroundImage: `url(${host}h5-active/16/bg.png)` }"
  >
    <section class="content">
      <div class="recharge-info">
        <h3>充值{{ config.recharge_money / 100 || "" }}元</h3>
        <div v-if="config.give_type === 1 || config.give_type === '1'">
          得<span>{{ config.recharge_money }}</span
          >书币+<span>{{ config.give_ticket }}</span
          >阅读劵
        </div>
        <div v-else>全站小说免费读({{ config.give_vip_days || 0 }}天)</div>
      </div>
      <img
        class="recharge-btn"
        :src="host + 'h5-active/16/btn.png'"
        @click="createOrder"
      />
    </section>
    <div class="tips">
      <p>-活动规则-</p>
      <p v-if="config.recharge_count != 9999">
        每一期活动单一用户仅能充值{{ config.recharge_count }}次
      </p>
      <p>虚拟商品购买后不可退换</p>
    </div>
  </main>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
    },
    host: String,
  },
  methods: {
    createOrder() {
      this.$emit("createOrder");
    },
  },
};
</script>

<style lang="less" scoped>
.wrap-bg {
  width: 100%;
  height: 100vh;
  min-height: 667px;
  max-height: 820px;
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
.content {
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translateX(-50%);
  height: 212px;
  background-size: cover;
  background-position: center;
}
.recharge-info {
  padding: 40px 0 30px;
  color: #e81a2d;
  font-size: 20px;
  font-weight: bold;
  h3 {
    font-size: 30px;
    margin-bottom: 18px;
    text-align: center;
  }
  div {
    white-space: nowrap;
    text-align: center;
  }
}
.recharge-btn {
  display: block;
  width: 185px;
  height: auto;
  margin: 0 auto;
}
.tips {
  font-weight: bold;
  position: absolute;
  bottom: 40px;
  left: 0;
  width: 100%;
  font-size: 16px;
  color: #fff;
  z-index: 1;
  line-height: 26px;
  p {
    text-align: center;
  }
}
</style>
